import type { IFSItem } from 'bz-core-controls/hooks-form/controls/field-select';

import { createContextForClass } from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import { computed } from 'mobx';
import { computedFn } from 'mobx-utils';

import type { LocationResponse } from 'tm3-core/api.dtos';
import ELocationStatus from 'tm3-core/interfaces/location/enums/status';

class LocationsStore extends CacheStore<LocationResponse> {
  constructor() {
    super('locations');
  }

  public search(searchTerm: string = ''): LocationResponse[] {
    if (!searchTerm) return this.CurrentLocations;
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.CurrentLocations.filter(
      (location) =>
        location?.name?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressLine1?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline2?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline5?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed
  get CurrentLocations(): LocationResponse[] {
    const live = ELocationStatus.Live.toString();
    return this.All.filter((x) => x.status === live); // not sure why this is a string
  }

  @computed
  get CurrentLocationForDropdown(): IFSItem[] {
    return this.CurrentLocations.map(this.toDropdown);
  }

  @computed
  get CurrentLocationForOnlineDropdown(): IFSItem[] {
    return this.CurrentLocations.map((c) => ({ text: c.name, payload: c.onlineGuid }));
  }

  public readonly findById = computedFn((id: number) => {
    const { _all } = this;

    return _all.get(id.toString());
  });

  public readonly toDropdown = computedFn((l: LocationResponse): IFSItem => {
    return { text: l.name, payload: l.id };
  });
}

export const [LocationsStoreCtx, useLocationsStore] = createContextForClass(LocationsStore);

export default LocationsStore;
